import React from 'react';
import styles from './styles.module.css';
import chevronRightBlack from 'assets/chevron-right-black.svg';
import * as Types from 'helpers/types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import checkCircle from 'assets/check-circle-green.svg';
import { useAnalytics, useMonitoringEvents, useODSCode } from 'hooks';

const DeliveryOptionCard = ({ data, deliveryOption, selectedPharmacyUser = false, analytics }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const selectedPharmacyDetails = useSelector((state) => state.paymentJourney.selectedPharmacyDetails);
  const addressList = useSelector((state) => state.addresses.addresses);
  const pharmaciesInRange = useSelector((state) => state.paymentJourney.pharmaciesInRange);
  const setAddress = useSelector((state) => state.paymentJourney.address);
  const getFromODSCode = useODSCode();
  const [postLog] = useMonitoringEvents();
  const [, postGoogleTag] = useAnalytics();

  const navigateDeliveryOption = async () => {
    if (deliveryOption) {
      if (deliveryOption.payload === 'collectFromPharmacy') {
        dispatch({ type: Types.CLEAR_PAYMENT_AND_EXEMPTION });
      }
      if (selectedPharmacyUser && deliveryOption.payload === 'collectFromPharmacy') {
        const pharmacyDetails = await getFromODSCode(selectedPharmacyDetails.ods_code);
        const addressPayload = {
          ...pharmacyDetails.data.address,
          ods_code: selectedPharmacyDetails.ods_code,
          name: pharmacyDetails.data.name,
        };
        dispatch({ type: Types.CLEAR_PAYMENT_AND_EXEMPTION });
        dispatch({ type: Types.ADDRESS_SET, payload: addressPayload });
      }
      if (deliveryOption.payload === 'pharmacyDelivery') {
        dispatch({ type: Types.CLEAR_PAYMENT_AND_EXEMPTION });
        if (!setAddress?.postcode) {
          const registeredAddress = addressList.find((address) => {
            return address?.name === 'GP Registered';
          });
          if (selectedPharmacyUser)
            dispatch({
              type: Types.ADDRESS_SET,
              payload: { ...registeredAddress, ods_code: selectedPharmacyDetails.ods_code },
            });
          else if (pharmaciesInRange.length === 1) {
            dispatch({
              type: Types.ADDRESS_SET,
              payload: { ...registeredAddress, ods_code: pharmaciesInRange[0].ods_code },
            });
          } else
            dispatch({
              type: Types.ADDRESS_SET,
              payload: { ...registeredAddress },
            });
        } else {
          if (selectedPharmacyUser) dispatch({ type: Types.ODS_SET, payload: selectedPharmacyDetails.ods_code });
          else if (pharmaciesInRange.length === 1) {
            dispatch({ type: Types.ODS_SET, payload: pharmaciesInRange[0].ods_code });
          }
        }
      }

      dispatch({ type: Types.DELIVERY_METHOD_SET, payload: deliveryOption.payload });

      Object.entries(analytics).forEach(([ key, value ]) => {
        if (value) {
          postLog(deliveryOption.event[key].logEvent);
          postGoogleTag(deliveryOption.event[key].ga);
        }
      });

      history.push(deliveryOption.location);
    }
  };

  return (
    <div
      id="delivery-option-card"
      className={`${styles.optionCard} ${deliveryOption ? styles.clickable : ''} drop-shadow`}
      tabIndex="0"
      onKeyPress={(event) => (event.key === 'Enter' ? navigateDeliveryOption() : null)}
      onClick={() => navigateDeliveryOption()}>
      <div className={styles.optionCardHeader}>
        {data.image && <img className={styles.deliveryImage} src={data.image.src} alt={data.image.alt} />}
        <h2 className="coop-t-h3">{data.title}</h2>
        {deliveryOption ? <img className={styles.chevronImage} src={chevronRightBlack} alt="Chevron" /> : null}
      </div>
      <div className={styles.divider} />
      {data.points.length > 1 ? (
        <ul className={styles.optionPointsContainer}>
          {data.points.map((point, index) => {
            return (
              <li key={index} className={styles.optionCardSubheader}>
                <img className={styles.optionPointsContainer__icon} src={checkCircle} alt="check circle" /> {point}
              </li>
            );
          })}
        </ul>
      ) : (
        <p className={styles.optionCardSubheader}>
          <img className={styles.optionPointsContainer__icon} src={checkCircle} alt="check circle" /> {data.points[0]}
        </p>
      )}
    </div>
  );
};

export default DeliveryOptionCard;
